import m2Sidebar from "@components/sidebar/m2_sidebar";
import m1_examRegMenu from '@components/examRegMenu/m1_examRegMenu.vue'


export default {
    components: {
        "m2Sidebar": m2Sidebar,
        "examRegMenu": m1_examRegMenu,

    },
    data() {
        var validateCode = (rule, value, callback) => {
            var reg = /^(?!^0*$)([A-Z0-9]{20})$|^(?!^0*$)([A-Z0-9]{17,18})$|^(?!^0*$)([A-Z0-9]{15})$/;
            if (value === "") {
                callback(new Error("请输入纳税人识别号"));
            } else if (!reg.test(value)) {
                callback(new Error("纳税人识别号错误，请输入正确纳税人识别号"));
            } else {
                callback();
            }
        };
        var validateEmail = (rule, value, callback) => {
            if (value == "") {
                callback(new Error("请输入邮箱"));
            } else if (
                !this.$common.validEmail(value)
            ) {
                callback(new Error("邮箱错误，请输入正确邮箱"));
            } else {
                callback();
            }
        };
        return {
            showPrice: false,
            domain: this.$store.state.examInfo.currentExamInfo.domain,
            examRegInfo: {},
            orderItem: [],
            totalMoney: 0,
            finalMoney: 0,
            tableData: [],
            invoice_status: true,
            invoice_switch: 1,
            invoice_type: 1,
            coupon_switch: false,
            couponForm: {
                couponId: ""
            },

            coupon_details: [],
            tips: "",
            errorMessage: "",
            bill_looking_up: "",
            name: "",
            isShow: false,
            invoiceForm: {
                needOrNot: 1,
                type: "2",
                name: "",
                code: "",
                email: "",
                add: "",
                tel: "",
                bank: "",
                b_account: "",
            },
            invoiceRule: {
                type: [{
                    required: true,
                    message: "发票类型不能为空",
                    trigger: "blur"
                }],
                name: [{
                        required: true,
                        message: "发票抬头不能为空",
                        trigger: "blur"
                    },
                    {
                        max: 32,
                        message: "超出最大长度32个字符",
                        trigger: "blur"
                    }
                ],
                code: [{
                        required: true,
                        message: "纳税人识别号不能为空",
                        trigger: "blur"
                    },
                    {
                        validator: validateCode,
                        trigger: "blur"
                    }
                ],
                email: [{
                        required: true,
                        message: "邮箱不能为空",
                        trigger: "blur"
                    },
                    {
                        validator: validateEmail,
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    computed: {
        haveInvoiceInfo: function () {
            if (this.invoiceForm.needOrNot && this.invoice_switch == 1) {
                if (this.invoice_type == 3) {
                    return false;
                } else {
                    if (this.invoiceForm.type == 1) {
                        if (
                            this.invoiceForm.name &&
                            this.invoiceForm.email &&this.$common.validEmail(this.invoiceForm.email)
                        ) {
                            return false;
                        }
                        return true;
                    } else if (this.invoiceForm.type == 2) {
                        if (
                            this.invoiceForm.name &&
                            this.invoiceForm.code &&
                            this.invoiceForm.email &&
                            /^(?!^0*$)([A-Z0-9]{20})$|^(?!^0*$)([A-Z0-9]{17,18})$|^(?!^0*$)([A-Z0-9]{15})$/.test(
                                this.invoiceForm.code
                            ) &&this.$common.validEmail(this.invoiceForm.email)
                        ) {
                            return false;
                        }
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return false;
            }
        }
    },
    methods: {
        getData: function () {
            this.$http
                .get(globalProvider.serviceUrl("e_reg/g/b/{reg_id}"), {
                    params: {
                        reg_id: this.examRegInfo.exam_registration_id
                    }
                })
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        this.tableData = data.body.data.subject_details;
                        this.finalMoney = data.body.data.full_price;
                        this.tips = data.body.data.tips;
                        this.invoice_status = data.body.data.invoice_status;
                        this.invoice_type = data.body.data.invoice_type;
                        this.invoice_switch = data.body.data.invoice_switch;
                        this.totalMoney = this.finalMoney;
                        this.coupon_switch = data.body.data.coupon_switch;
                        this.coupon_details = data.body.data.coupon_details;
                        if (this.coupon_details.length != 0) {
                            this.coupon_details.forEach(item => {
                                if (item.available) {
                                    this.totalMoney = this.totalMoney + item.discount;
                                }
                            })
                        }
                        this.coupon_details.forEach(item => {
                            item.discount = item.discount + "元";
                        })
                        // this.name = data.body.data.name;
                        // this.bill_looking_up = data.body.data.bill_looking_up;
                        if (!data.body.data.invoice_status) {
                            this.invoiceForm.needOrNot = 0;
                            if (
                                data.body.data.examinees_invoice_status != null
                            ) {
                                this.invoiceForm.needOrNot =
                                    data.body.data.examinees_invoice_status;
                            }
                        } else {
                            this.invoiceForm.needOrNot = 1;
                        }
                        if (data.body.data.bill_type == 1) {
                            this.invoiceForm.type = 1;
                            this.invoiceForm.name = data.body.data.name;
                            this.invoiceForm.email = data.body.data.email;
                        } else if (data.body.data.bill_type == 2) {
                            this.invoiceForm.type = 2;
                            this.invoiceForm.name =
                                data.body.data.bill_looking_up;
                            this.invoiceForm.code =
                                data.body.data.taxpayer_identification_number;
                            this.invoiceForm.email = data.body.data.email;
                        } else {
                            if (data.body.data.invoice_type != 3) {
                                this.invoiceForm.type = 1;
                                this.invoiceForm.name = data.body.data.name;
                                this.invoiceForm.email = data.body.data.email;
                            }
                        }
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message), {
                            confirmButtonText: "确定",
                            callback: action => {
                                if (data.body.message == "ERG_RSSA_PVOQ_03") {
                                    this.$router.push({
                                        name: "default_myRegister"
                                    });
                                }
                            }
                        });
                    }
                });
        },
        topay: function () {
            this.$confirm(
                    "支付完成前，请不要关闭此支付验证窗口。支付完成后，请根据您支付的情况点击下面按钮。",
                    "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                .then(() => {
                    this.$router.push({
                        name: 'default_myRegister'
                    });
                })
                .catch(() => {
                    return false;
                });
        },
        addCoupon: function () {

            if (this.couponForm.couponId) {
                this.$http.post(globalProvider.serviceUrl('e_reg/c/u/coupon'), {
                    cc: this.couponForm.couponId,
                    exam_reg_id: this.examRegInfo.exam_registration_id
                }).then(data => {
                    if (data.body.code == resultCode.Success) {
                        this.getData();
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.errorMessage = getErrorMessage(data.body.message)
                        this.$alert(getErrorMessage(data.body.message), {
                            confirmButtonText: "确定",
                        });
                    }
                })
            } else {
                this.$alert("未输入优惠券码", {
                    confirmButtonText: "确定",
                });
            }


        },
        cancelCoupon: function (row) {
            this.$confirm(
                    "确认取消绑定优惠券",
                    "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                .then(() => {
                    this.$http.post(globalProvider.serviceUrl('e_reg/c/d/coupon'), {
                        cc: row.coupon_code,
                        exam_reg_id: this.examRegInfo.exam_registration_id
                    }).then(data => {
                        if (data.body.code == resultCode.Success) {
                            this.$alert("取消成功", {
                                confirmButtonText: "确定",
                            });
                        } else if (data.body.code == resultCode.NotSuccess) {
                            if (data.body.message == 'EXM_R_UC_04') {} else if (data.body.message == 'EXM_R_UC_02') {
                                this.$alert('取消优惠券失败，请重试', {
                                    confirmButtonText: "确定",
                                });
                            } else {
                                this.$alert(getErrorMessage(data.body.message), {
                                    confirmButtonText: "确定",
                                });
                            }

                        }
                        this.getData();
                    })
                })
                .catch(() => {
                    return false;
                });
        },
        changeName(){
            if (this.invoiceForm.type == 1) {
                this.invoiceForm.add="";
                this.invoiceForm.tel="";
                this.invoiceForm.bank="";
                this.invoiceForm.b_account="";
              } 
        },
        payConfirm: function () {
            if (this.coupon_switch && this.coupon_details.length != 0 && !this.haveInvoiceInfo && this.domain != 'cas') {
                this.$confirm(
                        "您的报考已绑定优惠券，【确认支付】后优惠券不可取消绑定，请确认是否继续支付 ",
                        "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        }
                    )
                    .then(() => {

                        let routeUrl = this.$router.resolve({
                            name: 'default_examReg_payLoading',
                            query: {
                                needOrNot: this.invoiceForm.needOrNot,
                                email: this.invoiceForm.email,
                                add: this.invoiceForm.add,
                                tel: this.invoiceForm.tel,
                                bank: this.invoiceForm.bank,
                                b_account: this.invoiceForm.b_account,
                                type: this.invoice_type != 3 ? this.invoiceForm.type : 3,
                                code: this.invoiceForm.code,
                                name: this.invoiceForm.name,
                                invoice_switch: this.invoice_switch,
                                r_id: this.examRegInfo.exam_registration_id,

                            }
                        });
                        window.open(routeUrl.href);
                        this.topay();

                    })
                    .catch(() => {
                        return false;
                    });
            } else {
                if (!this.haveInvoiceInfo) {
                    let routeUrl = this.$router.resolve({
                        name: 'default_examReg_payLoading',
                        query: {
                            needOrNot: this.invoiceForm.needOrNot,
                            email: this.invoiceForm.email,
                            add: this.invoiceForm.add,
                            tel: this.invoiceForm.tel,
                            bank: this.invoiceForm.bank,
                            b_account: this.invoiceForm.b_account,
                            type: this.invoice_type != 3 ? this.invoiceForm.type : 3,
                            code: this.invoiceForm.code,
                            name: this.invoiceForm.name,
                            invoice_switch: this.invoice_switch,
                            r_id: this.examRegInfo.exam_registration_id,
                        }
                    });
                    window.open(routeUrl.href);
                    this.topay();
                }
            }
        },
        isShowPrice() {
            this.showPrice = globalProvider.isGuideDomain(this.domain);
        }
    },
    created: function () {
        this.examRegInfo = this.$store.state.examRegInfo.examRegInfo;
        this.$store.commit("setHeaderState", "3");
        this.getData();
        this.isShowPrice();
    }
};